import React from 'react';

import { ExpandMore } from '@mui/icons-material';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Grid,
} from '@mui/material';

import * as colors from 'commons/styles/colors';
import { IInboundTaskItemWithSummary } from 'commons/types';

import { InboundTaskReceiveBinList } from './InboundTaskReceiveBinList.component';

interface InboundSkuListProps {
  inboundTaskItems: IInboundTaskItemWithSummary[];
  defaultExpanded?: boolean;
}
export const InboundSkuReceiveList: React.FC<InboundSkuListProps> = ({
  inboundTaskItems,
  defaultExpanded,
}) => {
  return (
    <>
      {inboundTaskItems.map((item, i) => {
        const qtyColor =
          item.quantity === item.receivedQty
            ? colors.PRIMARY_GREEN
            : item.receivedQty === 0
            ? colors.PRIMARY_BLACK
            : colors.PRIMARY_YELLOW;
        return (
          <Accordion
            defaultExpanded={
              item.receive_actual.length !== 0 && defaultExpanded
            }
          >
            <AccordionSummary
              expandIcon={<ExpandMore />}
              aria-controls={`panel${i}-content`}
              id={`panel${i}-header`}
            >
              <Grid container style={{ fontSize: '14px', fontWeight: 700 }}>
                <Grid
                  item
                  xs={8}
                  data-testid={`TextInboundSummarySKU-${i + 1}`}
                >
                  {item.sku_code}
                </Grid>
                <Grid
                  item
                  xs={4}
                  style={{
                    textAlign: 'right',
                    verticalAlign: 'middle',
                    color: qtyColor,
                  }}
                >
                  {item.receivedQty} / {item.quantity}
                </Grid>
              </Grid>
            </AccordionSummary>
            <AccordionDetails>
              <Grid />
              <InboundTaskReceiveBinList receiveActual={item.receive_actual} />
            </AccordionDetails>
          </Accordion>
        );
      })}
    </>
  );
};
